var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:({
    marginLeft: ("-" + (_vm.gutter / 2) + "px"),
    marginRight: ("-" + (_vm.gutter / 2) + "px"),
    marginBottom: (_vm.bottomOffset + "px"),
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }